<template>
    <div>

        <vue-headful title="Email Alert :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`${backRoute}`">
                        {{ backLabel }}
                    </router-link>
                </li>
                <li class="breadcrumb-item active">
                    Email Alert
                </li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-lg-5 col-12">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                id: this.$route.params.id,
                loading: true,
                alert: {},
            }
        },

        computed: {

            backRoute(){
                //Make sure it's set
                if(!this.alert.asset_type)
                {
                    return '';
                }

                //Setup
                var route = '/'+this.alert.asset_type.toLowerCase() + 's';

                //Handle it
                switch(this.this.alert.asset_type)
                {
                    case 'Observation':

                        break;
                }

                //Send it
                return route;
            },

            backLabel(){
                //Setup
                var label = this.alert.asset_type + 's';

                //Handle it
                switch(this.alert.asset_type)
                {
                    case 'Observation':

                        break;
                }

                //Send it
                return label;
            },
        },

        methods: {
            //Load the Account
            getAlert(){
                //Send it
                this.$http.get('/email-alerts/view/' + this.id)
                    .then(res => {
                        //Set data
                        this.alert = res.data.alert;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },
        },

        mounted(){
            //Get it
            this.getAlert();
        }
    }
</script>
